import React, {Component} from "react";
import styled from "styled-components";
import { Title, Header, Body, ButtonTitle, ActionButtonTitle } from "../components/Fonts"
import {
  PageContainer, ReversedSectionContainer,
  SectionContainer,
  SectionGroup,
  SectionItem, SectionSpacer
} from "../components/conatiner/Container";
import NavigationHeader from "../components/navigationHeader/NavigationHeader";

import cameraSpeaker from "../images/illustrations/cameraSpeaker.png";
import { ColoredAcionButton, Button, ActionButton, ButtonIcon } from "../components/button/ActionButton";
import {CenteredColoredActionButtonTitle} from "../components/Fonts";
import TransparentNavigationHeader from "../components/navigationHeader/TransparentNavigationHeader";
import TransparentFooter from "../components/footer/TransparentFooter";

const Logo = styled.div`
  width: 400px;
  height: calc(100vh - 440px);
  background: url(${cameraSpeaker}) no-repeat center;
  background-size: 400px;
  margin: 0 auto;

  @media only screen and (max-width: 768px) {
    max-width: 400px;
    width: 100%;
    height: calc(100vh - 360px);
    background-size: 100%;
    margin: 40px auto;
  }
`;

const Description = styled.span`
  font: 40px "Euclid Circular A", sans-serif;
  font-weight: 600;
  line-height: 48px;
  color: #FFFFFF;
  display: inline-block;
  text-align: center;
  max-width: 400px;

  @media only screen and (max-width: 768px) {
    font: 32px "Euclid Circular A", sans-serif;
    font-weight: 800;
    line-height: 40px;
    text-align: center;
  }
`;

const ColoredPageContainer = styled(PageContainer)`
  max-width: 100%;
  background-image: linear-gradient(to bottom right, #FE992E, #FE6A33, #FE3729);
`;

class PlayPage extends Component {
  //  As the landing pages is static, there is no need to re-render.
  shouldComponentUpdate() {
    return false;
  }

  onAppStore = () => {
    // @ts-ignore
    window.open("https://apps.apple.com/us/app/zebra-share-talking-photos/id1548469840", '_blank').focus();
  }

  render() {
    let parts = window.location.href.split("/")
    let name = parts[parts.length - 1]
    return (
      <ColoredPageContainer>
        <TransparentNavigationHeader isPreview={false}/>
        <Logo/>
        <div style={{display: "flex", justifyContent: "center"}}>
          <Description>You have a message from {name}!</Description>
        </div>
        <div style={{display: "flex", justifyContent: "center", paddingTop: "30px"}}>
        <ColoredAcionButton height={64} onClick={this.onAppStore}>
          <CenteredColoredActionButtonTitle>Download to View</CenteredColoredActionButtonTitle>
        </ColoredAcionButton>
        </div>
      <TransparentFooter/>
      </ColoredPageContainer>
    );
  }
}

export default PlayPage;